export default function (element: HTMLElement, dataset: DOMStringMap) {
  //   console.log("test", element);
}
